export const de = 'de';
export const en = 'en';
export const es = 'es';
export const fr = 'fr';

const locales = Object.freeze([de, en, es, fr]);

export default locales;
